import AjaxLoader from '../utilities/ajax-loader';

export default class RailsResource {
  constructor(opts) {
    let configuration = Object.assign({ ajaxLoader: true }, opts);
    this.url = configuration['url'];
    this.resource = configuration['resource'];
    this.ajaxLoader = configuration['ajaxLoader'];
  }

  // GET resources
  all() {
    return this.get(`${this.route}.json`);
  }

  // GET resources/id
  find(id) {
    return this.get(`${this.route}/${id}.json`);
  }

  // GET resources?where=condition
  where({ queryParams = [] }) {
    let endpoint = `${this.route}.json?${queryParams.join('&')}`;
    return this.get(endpoint);
  }

  create(resource) {
    return this.post(`${this.route}.json`, true, resource);
  }

  update(id, resource) {
    return this.patch(`${this.route}/${id}.json`, true, resource);
  }

  destroy(id) {
    return this.delete(`${this.route}/${id}.json`, true);
  }

  endpoint({ path = '', queryParams = [] }) {
    return `${path}.json?${queryParams.join('&')}`;
  }

  patch(endpoint, parseJSON, data = {}) {
    data['_method'] = 'patch';
    return this.post(endpoint, parseJSON, data);
  }

  put(endpoint, parseJSON, data = {}) {
    data['_method'] = 'put';
    return this.post(endpoint, parseJSON, data);
  }

  delete(endpoint, parseJSON) {
    return new Promise((resolve, reject) => {
      fetch(endpoint, {
        method: 'delete'
      })
        .then((resp) => {
          AjaxLoader.hide();
          return resp.text()
        })
        .then((response) => {
          if (!parseJSON) return resolve(response);
          let parsedResponse = this.parseJSON(response);
          return resolve(parsedResponse);
        })
        .catch((error) => reject(error))
    });
  }

  post(endpoint, parseJSON, data = {}) {
    this.setCSRFToObject(data);
    !!this.ajaxLoader && AjaxLoader.show();

    return new Promise((resolve, reject) => {
      fetch(endpoint, {
        method: 'post',
        body: this.convertToFormData(data)
      })
        .then((resp) => {
          AjaxLoader.hide();
          return resp.text()
        })
        .then((response) => {
          if (!parseJSON) return resolve(response);

          let parsedResponse = this.parseJSON(response);
          !!parsedResponse ? resolve(parsedResponse) : reject('error on parsing');
        })
        .catch((error) => reject(error))
    });
  }

  get(endpoint, parseJSON = true) {
    return this.call(endpoint, parseJSON);
  }

  rawCall(endpoint, opts) {
    let method, body, parseJSON;
    ({ method = 'get', body, parseJSON = true } = opts);
    !!this.ajaxLoader && AjaxLoader.show();
    return new Promise((resolve, reject) => {
      fetch(endpoint, {
        headers: this.formHeaders(),
        method: method,
        credentials: 'include',
        body: JSON.stringify(body)
      })
        .then((resp) => {
          AjaxLoader.hide();
          return resp.text()
        })
        .then((response) => resolve(parseJSON ? JSON.parse(response) : response))
        .catch((error) => reject(error))
    });
  }

  call(endpoint, parseJSON = true) {
    !!this.ajaxLoader && AjaxLoader.show();
    return new Promise((resolve, reject) => {
      fetch(endpoint, {
        mode: 'no-cors',
        method: 'get'
      })
        .then((resp) => {
          AjaxLoader.hide();
          return resp.text()
        })
        .then((response) => resolve(parseJSON ? JSON.parse(response) : response))
        .catch((error) => reject(error))
    });
  }

  formHeaders() {
    return new Headers({
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-Token': this.authenticityToken(),
    });
  }

  authenticityToken() {
    return document.querySelector('meta[name=csrf-token]').content;
  }

  convertToFormData(params) {
    return Object.entries(params)
        .reduce((acc, [key, value]) => {
            if (Array.isArray(value)) {
              value.forEach((v, k) => acc.append(`${key}[]`, v));
            } else if (value === null) {
              acc.append(key, '');
            } else if (typeof value === 'object' && !(value instanceof File) && !(value instanceof Date)) {
              Object.entries(value).forEach((v, k) => acc.append(`${key}[${v[0]}]`, v[1]));
            } else {
              acc.append(key, value);
            }

            return acc;
        }, new FormData());
  }

  setCSRFToObject(object) {
    object[document.querySelector('meta[name="csrf-param"]').content] = document.querySelector('meta[name="csrf-token"]').content
  }

  parseJSON(raw) {
    try {
      return JSON.parse(raw);
    } catch (err) {
      return false;
    }
  }

  get route() {
    return `${this.url}/${this.resource}`;
  }
}